import * as api from "@/api/williams/certificates";
import { queryKeys } from "../../queryKeys";
import { useMutation, useQueryClient } from "react-query";

export function usePinCertificate() {
  const queryClient = useQueryClient();

  return useMutation(async (id: string) => {
    await api.togglePinned(id);
    queryClient.invalidateQueries(queryKeys.certificates.list());
  });
}
